interface IDestroyHandler {
    event?: string;
    element: Element;
    handler: (event: Event) => void;
}

const destroyHandlers: IDestroyHandler[] = [];

const init = () => {
    const articleWithVideoWrappers = document.querySelectorAll('.js-article-with-video-wrapper');
    const cursor = document.querySelector('.cursor');

    articleWithVideoWrappers.forEach((wrapper) => {
        const watchButton = wrapper.querySelector('.js-article-card-watch-btn');
        const videoPopup = wrapper.querySelector('.js-video-popup');
        const closeButtons = wrapper.querySelectorAll('.js-video-popup-close-btn');
        const videoFrame = wrapper.querySelector<HTMLIFrameElement>('.js-video-popup-frame');

        let srcResetTimeout: NodeJS.Timeout;

        let isFirstTimeOpening = true;

        const handleWatchButtonClick = (event: Event) => {
            event.stopPropagation();
            event.preventDefault();

            if (srcResetTimeout) {
                clearTimeout(srcResetTimeout);
            }

            if (isFirstTimeOpening) {
                videoFrame?.setAttribute('src', videoFrame.dataset.src ?? '');
                isFirstTimeOpening = false;
            }

            videoPopup?.classList.add('active');
            cursor?.classList.add('cursor--force-hidden');
        };

        const handleCloseButtonClick = () => {
            videoPopup?.classList.remove('active');

            srcResetTimeout = setTimeout(() => {
                videoFrame?.setAttribute('src', videoFrame.src);
                cursor?.classList.remove('cursor--force-hidden');
            }, 600);
        };

        watchButton?.addEventListener('click', handleWatchButtonClick);

        if (watchButton) {
            destroyHandlers.push({ element: watchButton, handler: handleWatchButtonClick });
        }

        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener('click', handleCloseButtonClick);

            destroyHandlers.push({ element: closeButton, handler: handleCloseButtonClick });
        });
    });
};

const destroy = () => {
    destroyHandlers.forEach((handlerItem) => {
        handlerItem.element.removeEventListener(handlerItem.event ?? 'click', handlerItem.handler);
    });
};

const _module = { init, destroy };

export default _module;
